export default __webpack_public_path__ + "static/devsecops-transformation-saas-compliance-b006b6f78a991302c7a5012f79106077.jpg";